export default {
  'menu.AttendanceRecordLocationPage': '查看位置',
};
